import React from 'react';

import '../Estilos/EstiloSap.css';
import 'bootstrap/dist/css/bootstrap.css';
import '../New Template/Botones.css';
import '../New Template/Formularios1.css';
import Swal from 'sweetalert2';
import ConsecutivosTabla from './ConsecutivosTabla';
import withReactContent from 'sweetalert2-react-content';
import { ListaSucursales, ListaTerminales } from '../Comunes/Listas';

const Zona = (props) => {

    const MySwal = withReactContent(Swal);

    const estilos = {
        contenedorPrincipal: {
            padding: '12px',
            backgroundColor: '#f4f6f8',
            borderRadius: '10px'
        },
        encabezado: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '15px',
            padding: '10px 12px',
            backgroundColor: '#ffffff',
            border: '1px solid #dcdcdc',
            borderRadius: '8px',
            boxShadow: '0 1px 4px rgba(0,0,0,0.08)'
        },
        titulo: {
            margin: 0,
            fontWeight: 'bold',
            color: '#2f4050'
        },
        botonAuto: {
            backgroundColor: '#2f80ed',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            padding: '7px 14px',
            fontWeight: 'bold',
            cursor: 'pointer'
        },
        grid: {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(420px, 1fr))',
            gap: '14px'
        },
        tarjeta: {
            backgroundColor: '#ffffff',
            border: '1px solid #d9e2ec',
            borderRadius: '10px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
            overflow: 'hidden'
        },
        tarjetaHeader: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '10px 12px',
            backgroundColor: '#eef4fb',
            borderBottom: '1px solid #d9e2ec'
        },
        nombreBloque: {
            fontWeight: 'bold',
            color: '#243b53',
            fontSize: '14px'
        },
        codigo: {
            fontSize: '12px',
            backgroundColor: '#d9eafd',
            color: '#1f4e79',
            padding: '3px 7px',
            borderRadius: '12px',
            marginLeft: '8px',
            fontWeight: 'bold'
        },
        botonAgregar: {
            backgroundColor: '#198754',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            padding: '5px 10px',
            fontSize: '13px',
            fontWeight: 'bold',
            cursor: 'pointer'
        },
        cuerpoTarjeta: {
            padding: '10px'
        }
    };

    const ObtenerNombre = (Gestion) => {
        switch (Gestion) {
            case 'FAC': return 'Factura Electrónica';
            case 'TIQ': return 'Tiquete Electrónico';
            case 'EXP': return 'Factura Exportación';
            case 'NC': return 'Nota Crédito';
            case 'ND': return 'Nota Débito';
            case 'FEC': return 'Factura Electrónica Compra';
            case 'MR': return 'Confirmación Compra';
            case 'COT': return 'Cotización';
            case 'REP': return 'Recibo Pago Electrónico';
            case 'PED': return 'Pedido';
            default: return '';
        }
    };

    const ObtenerTextoBoton = (Gestion) => {
        switch (Gestion) {
            case 'FAC': return '+ Factura';
            case 'TIQ': return '+ Tiquete';
            case 'EXP': return '+ Exportación';
            case 'NC': return '+ Nota Crédito';
            case 'ND': return '+ Nota Débito';
            case 'FEC': return '+ FEC';
            case 'MR': return '+ Conf. Compra';
            case 'COT': return '+ Cotización';
            case 'REP': return '+ REC';
            case 'PED': return '+ Pedido';
            default: return '+ Nuevo';
        }
    };

    const NuevoConsecutivo = async (Gestion) => {

        let Nombre = ObtenerNombre(Gestion);

        const { value: formValues } = await MySwal.fire({
            title: 'Nuevo Consecutivo ' + Nombre,
            html: (
                <div>
                    <select id="AgrSucursal" name="AgrSucursal" className="form-group">
                        {ListaSucursales.map((option, i) => (
                            <option key={i} value={option.value}>{option.span}</option>
                        ))}
                    </select>

                    <select id="AgrTerminal" name="AgrTerminal" className="form-group">
                        {ListaTerminales.map((option, i) => (
                            <option key={i} value={option.value}>{option.span}</option>
                        ))}
                    </select>

                    <input
                        id="swal-input2"
                        autoComplete="off"
                        className="swal2-input"
                        placeholder="Siguiente"
                    />
                </div>
            ),
            focusConfirm: false,
            preConfirm: () => {
                const COD_Sucursal = document.getElementById('AgrSucursal').value;
                const COD_Terminal = document.getElementById('AgrTerminal').value;
                const Siguiente = document.getElementById('swal-input2').value;

                if (!COD_Sucursal || !COD_Terminal || !Siguiente) {
                    Swal.showValidationMessage('Todos los campos son requeridos');
                    return false;
                }

                return {
                    Tipo: Gestion,
                    Sucursal: COD_Sucursal,
                    Terminal: COD_Terminal,
                    Siguiente: Siguiente
                };
            }
        });

        if (formValues) {
            props.AgregarConsecutivo(formValues);
        }
    };

    const bloques = [
        { gestion: 'FAC' },
        { gestion: 'TIQ' },
        { gestion: 'EXP' },
        { gestion: 'NC' },
        { gestion: 'ND' },
        { gestion: 'FEC' },
        { gestion: 'MR' },
        { gestion: 'COT' },
        { gestion: 'REP' },
        { gestion: 'PED' }
    ];

    return (
        <div style={estilos.contenedorPrincipal}>

            <div style={estilos.encabezado}>
                <h4 style={estilos.titulo}>Consecutivos</h4>

                {props.IdCia === 0 ? (
                    <button
                        id="AutoAsignar"
                        name="AutoAsignar"
                        style={estilos.botonAuto}
                        onClick={() => props.AutoAsignar()}
                    >
                        Auto Asignar
                    </button>
                ) : null}
            </div>

            <div style={estilos.grid}>
                {bloques.map((bloque) => (
                    <div key={bloque.gestion} style={estilos.tarjeta}>

                        <div style={estilos.tarjetaHeader}>
                            <div>
                                <span style={estilos.nombreBloque}>
                                    {ObtenerNombre(bloque.gestion)}
                                </span>
                                <span style={estilos.codigo}>
                                    {bloque.gestion}
                                </span>
                            </div>

                            <button
                                id={'Nuevo' + bloque.gestion}
                                name={'Nuevo' + bloque.gestion}
                                style={estilos.botonAgregar}
                                onClick={() => NuevoConsecutivo(bloque.gestion)}
                            >
                                {ObtenerTextoBoton(bloque.gestion)}
                            </button>
                        </div>

                        <div style={estilos.cuerpoTarjeta}>
                            <ConsecutivosTabla
                                gestion={bloque.gestion}
                                EliminarConsecutivo={props.EliminarConsecutivo}
                                ActualizarConsecutivo={props.ActualizarConsecutivo}
                                LosConsecutivos={props.LosConsecutivos}
                            />
                        </div>

                    </div>
                ))}
            </div>

        </div>
    );
};

export default Zona;